export const getExplorer = () => process.env.REACT_APP_BLOCK_EXPLORER;

export const explorer = getExplorer();
